import { GOOGLE_MAPS_URL } from '../../../../constants';
import { StaticGoogleMapURLParams } from '../StaticGoogleMap.types';

export const getStaticGoogleMapUri = ({
    width,
    height,
    scale,
    latitude,
    longitude,
    zoom,
    marker,
    channel
}: StaticGoogleMapURLParams): string => {
    const baseGoogleMapUrl = `${GOOGLE_MAPS_URL}/maps/api/staticmap?size=${width}x${height}&format=jpg&scale=${scale}&center=${latitude},${longitude}&maptype=roadmap&zoom=${zoom}&channel=${channel}&client=gme-zooplapropertygroup&sensor=false`;

    if (marker) {
        const { standard, retina } = marker.iconUrl;
        const iconUrl = scale === 2 ? retina : standard;

        return (
            baseGoogleMapUrl +
            `&markers=scale:${scale}%7Cicon:${iconUrl}%7C${marker.latitude},${marker.longitude}`
        );
    }

    return baseGoogleMapUrl;
};
